module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921105651_T.44ce71ce.jpg";